module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "width": "100%",
      "background": "#bdd6ec",
      "border": "1px solid #337ab7",
      "border-radius": "5px",
      "text-align": "start",
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.isEditing == true) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textContent),
      expression: "textContent"
    }],
    staticClass: "form-control txt_edit",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.textContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textContent = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "txt_edit",
    staticStyle: {
      "width": "100%",
      "text-align": "start",
      "min-height": "222px",
      "border": "1px solid #ccc",
      "border-radius": "5px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.textContent.replace(/\n/g, '<br>'))
    }
  }), _vm._v(" "), (_vm.showEdit) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing == false),
      expression: "isEditing == false"
    }],
    staticClass: "btn btn-primary btn_edit",
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing == true),
      expression: "isEditing == true"
    }],
    staticClass: "btn btn-primary btn_edit",
    staticStyle: {
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing == true),
      expression: "isEditing == true"
    }],
    staticClass: "btn btn-primary btn_edit",
    staticStyle: {
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("キャンセル")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7439048","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info-box.vue
// module id = 1060
// module chunks = 0